import { gql } from "@apollo/client"

export const getAllTaskMasterQuery = gql`
  query getAllTaskMaster(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllTaskMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        taskName
        ageGroupId
        iconURL
        error {
          statusCode
          message
        }
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
export const deleteTaskMasterMutation = gql`
  mutation deleteTaskMaster($id: Int!) {
    deleteTaskMaster(id: $id) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getOneTaskMasterQuery = gql`
  query getTaskMaster($id: Int!) {
    getOneTaskMaster(id: $id) {
      id
      taskName
      ageGroupId
    }
  }
`
export const createTaskMasterMutation = gql`
  mutation createTaskMaster($data: [taskMasterInput]) {
    createTaskMasters(data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const updateTaskMasterMutation = gql`
  mutation updateTaskMaster($id: Int!, $data: taskMasterInput) {
    updateTaskMaster(id: $id, data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getAllAgeGroup = gql`
  query getAgeGroups(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAgeGroupMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        ageGroupTitle
      }
    }
  }
`
export const fileUploadQuery = gql`
  query getUploadUrl($type: String!, $fileName: String!) {
    getUploadUrl(type: $type, fileName: $fileName) {
      status

      url

      error {
        message
      }
    }
  }
`
